import Skeleton from '@/components/ui/custom/Skeleton';
import TopicsContainer from '@/components/topics/TopicsContainer';

export function CourseBoxHeaderSkeleton() {
  return (
    <Skeleton className="h-[100px] w-full rounded-lg bg-primary-content" />
  );
}

export function CourseBoxMainSkeleton() {
  return (
    <main className="relative flex gap-4 w-full h-full min-h-[650px]">
      <TopicsContainer className="relative w-1/5 min-w-[250px] max-w-[500px] min-h-24 flex flex-col gap-2.5 border-neutral-content">
        <Skeleton className="h-1/3 w-full rounded-lg bg-primary-content" />
        <Skeleton className="h-1/3 w-full rounded-lg bg-primary-content" />
      </TopicsContainer>
      <TopicsContainer className="relative grow h-full flex">
        <Skeleton className="h-full w-full rounded-lg bg-primary-content" />
      </TopicsContainer>
    </main>
  );
}

export function LessonBoxSkeleton() {
  return (
    <TopicsContainer className="relative grow flex flex-col gap-2.5 border-neutral-content">
      <Skeleton className="h-full w-full rounded-lg bg-primary-content" />
    </TopicsContainer>
  );
}
